module.exports = __webpack_public_path__ + "img/2_57.a91e66fe.png";